module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Write-27181dd1e1cd752c996b1641e001f49e.svg";